import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

type IConfirmDeleteCardDialogProps = {
  open: boolean;
  cardTitle: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  boardMode?: 'contacts' | 'boards';
};

export const ConfirmDeleteCardDialog = ({
  open,
  cardTitle,
  onClose,
  onConfirm,
  loading,
  boardMode,
}: IConfirmDeleteCardDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    disableEnforceFocus
    disableEscapeKeyDown={loading}
    PaperProps={{ style: { pointerEvents: 'auto', zIndex: 1302 } }}
    BackdropProps={{ style: { pointerEvents: 'auto', zIndex: 1301 } }}
    sx={{
      zIndex: 1302,
    }}
  >
    <DialogTitle>
      Delete {boardMode === 'contacts' ? 'Contact' : 'Card'}
    </DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to delete the{' '}
        {boardMode === 'contacts' ? 'contact' : 'card'} <b>{cardTitle}</b>?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          console.log('Cancel delete');
          onClose();
        }}
        color="inherit"
        disabled={loading}
      >
        Cancel
      </Button>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          onConfirm();
        }}
        color="error"
        variant="contained"
        disabled={loading}
      >
        {loading ? 'Deleting...' : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);
